import type { NavLink } from '../types/content';

export const headerLinks: NavLink[] = [
  { label: 'Services', href: '#services' },
  { label: 'Our Work', href: '#work' },
  { label: 'Process', href: '#process' },
  { label: 'Service Area', href: '#area' },
  { label: 'Reviews', href: '#reviews' },
];

export const footerLinks: NavLink[] = [
  { label: 'Home', href: '#top' },
  { label: 'Services', href: '#services' },
  { label: 'Our Work', href: '#work' },
  { label: 'About', href: '#about' },
  { label: 'Service Areas', href: '#area' },
  { label: 'Contact', href: '#estimate' },
];
